/**
 * @file    useIdleTimeout.js
 * 
 *          Hook for initializing the useidleTimer hook with proper properties.
 *
 * @author  David Courtis <david@distributive.network>
 * @date    Feb. 2024
 */
import { useState, useEffect } from 'react'
import { useIdleTimer } from 'react-idle-timer'
import { LoginOperations } from '@/features/auth';
import { subscribe } from '@/features/auth/api/SessionExtension.js';

// In the portal, dcp-dom-tk is loaded in the index.html page everything else loads from
if (!globalThis.modules.portal)
  globalThis.modules.portal = {};
globalThis.modules.portal.resetIdleTimer = resetIdleTimer; /* dcp-client dom-tk */
console.log('set modules');
var idleTimer, paused;

/**
 * Hook for initializing the useidleTimer hook with proper properties.
 *
 * @param onIdle   function to notify user when idle timeout is close
 * @param idleTime number of seconds to wait before user is logged out
 */
export const useIdleTimeout = ({ onIdle, idleTime = 10000 }) => {
  const MODAL_TIMEOUT = Number(import.meta.env.VITE_IDLE_MODAL_TIMEOUT);
  const [isIdle, setIdle] = useState(false);

  const handleIdle = () => {
    setIdle(true);
    LoginOperations.handleLogout();
  }

  idleTimer = useIdleTimer({
    timeout: idleTime,
    promptBeforeIdle: MODAL_TIMEOUT,
    onPrompt: onIdle,
    onIdle: handleIdle,
    debounce: 1000
  });

  useEffect(() => {
    // Subscribe will fire immediately, honoring any pre-existing leases
    const unsubscribe = subscribe((isExtended) => {
      if (isExtended)
      {
        paused = true;
        idleTimer.pause();
      }
      else
      {
        paused = false;
        idleTimer.start(); // Restarts full idle window
      }
    });
    return unsubscribe;
  }, []);

  return {
    isIdle,
    setIdle,
    idleTimer
  }
}

export function resetIdleTimer()
{
  if (!paused && idleTimer)
    idleTimer.reset();
}